import React, { PropTypes, Component } from 'react'
import styled from 'styled-components'
import Grid, { Third } from 'grid-styled'
import { Fonts, Metrics, Colors } from '../../Themes'
import Table from '../../components/Table'
import placeholder from '../../../public/img/Search/america.jpg'
import cityPlaceholder from '../../../public/img/Defaults/default_city.jpg'
import countryPlaceholder from '../../../public/img/Defaults/default_country.jpg'
import continentPlaceholder from '../../../public/img/Defaults/default_continent.jpg'
import ThemeContainer from '../../components/ThemeContainer'
import Loader from '../../components/Loader'

const Image = styled.div`
  width: 100%;
  height: 395px;
  background: url(${props => (props.image ? props.image : placeholder)})
    no-repeat center;
  background-size: cover;
  display: table;
  position: relative;
`

const Path = styled.div`
  position: absolute;
  right: ${Metrics.margins.larger};
  top: ${Metrics.margins.larger};
  cursor: pointer;
  ${Fonts.style.Input};
  color: ${Colors.black};
`

const Title = styled.div`
  background: rgba(255, 255, 255, 0.6);
  display: table-cell;
  vertical-align: middle;

  h1 {
    ${Fonts.style.Title};
  }

  p {
    margin-top: ${Metrics.margins.large};
    ${Fonts.style.Header};
  }
`

const ResultTitleContainer = styled.div`
  background: rgba(0, 0, 0, 0.3);
  ${Fonts.style.Title};
  text-align: center;
  color: ${Colors.white};
  text-transform: capitalize;
  word-break: break-all;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  display: table;
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0.7);
    color: ${Colors.primary};
  }
`

const ResultTitle = styled.div`
  display: table-cell;
  vertical-align: middle;
`

const Result = styled(Third)`
  padding-left: 0;
  padding-right: ${Metrics.margins.small};
  overflow: hidden;

  @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
    padding-right: 0;
    display: block;
    width: 100%;
  }
`

const ResultContainer = styled.div`
  height: 250px;
  width: 100%;
  margin-bottom: ${Metrics.margins.small};
  display: block;
  position: relative;
  overflow: hidden;

  img {
    transition: 0.3s ease transform;
    height: 250px;
    width: 100%;
    cursor: pointer;
    background: url(${props => {
        switch (props.type) {
          case 'continent':
            return continentPlaceholder
          case 'country':
            return countryPlaceholder
          default:
            return cityPlaceholder
        }
      }})
      no-repeat center;
    background-size: cover;
    margin-bottom: ${Metrics.margins.small};
    display: table;
    position: relative;
  }

  &:hover {
    img {
      transform: scale(1.1);
      transition: 0.3s ease transform;
    }
  }
`

const ResultsContainer = styled.div`
  text-align: left;
  position: relative;
  margin-top: ${props => (props.noMarginTop ? 0 : Metrics.margins.base)};
  height: ${props =>
    props.isTable
      ? `calc(${window.innerHeight}px - ${Metrics.components.navbarDefault})`
      : 'auto'};
`

const Description = styled(Grid)`
  margin-top: 70px;
  margin-bottom: ${Metrics.margins.big};
  ${Fonts.style.Text};
  text-align: center;
`

const Container = styled.section`
  text-align: center;
  height: calc(100vh - ${Metrics.components.navbarDefault});
  overflow: scroll;
  position: relative;

  .loader {
    position: fixed;
    background: none;
    width: 50px;
    height: 50px;
    bottom: 50px;
    left: 20px;
    top: inherit;
  }
  .resultBody {
    .hidden {
      display: none !important;
    }

    .table {
      text-align: left;
      margin-top: 70px;
      height: 500px;
      tbody {
        tr {
          td {
            svg {
              height: 50px;

              &.notFavorite {
                path {
                  fill: ${Colors.darkGrey};
                }
              }
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
    height: calc(100vh - ${Metrics.components.navbarDefault});
  }
`

class SearchResult extends Component {
  constructor (props) {
    super(props)
    this.handleScroll = this.handleScroll.bind(this)
  }

  handleScroll () {
    const { isFetching, canLoadMore, loadMore } = this.props
    const element = document.getElementById('results-page')
    var hiddenPixels = element.scrollTop
    var difference = element.scrollHeight - element.clientHeight
    var scrollPrecentage = hiddenPixels / difference * 100
    if (
      loadMore &&
      canLoadMore &&
      !isFetching &&
      parseInt(scrollPrecentage, 10) > 90
    ) {
      loadMore()
    }
  }

  table () {
    const {
      results,
      tableKeys,
      isFetching,
      handleClick,
      loadMore,
      handleSort,
      canLoadMore,
      parent
    } = this.props
    const width = window.screen.availWidth
    const height = window.innerHeight - 60
    return (
      <ResultsContainer
        id='propertyList'
        isTable
        noMarginTop={!parent.description}>
        <Table
          keys={tableKeys}
          data={results}
          isFetching={isFetching}
          rowClick={handleClick}
          loadMore={loadMore}
          width={width}
          height={height}
          handleSort={handleSort}
          canLoadMore={canLoadMore}
        />
      </ResultsContainer>
    )
  }

  cards () {
    const { results, handleClick, type } = this.props
    return (
      <ThemeContainer>
        <ResultsContainer id='results-body'>
          {results.map((el, index) => {
            return (
              <Result
                type={type}
                key={`result-${el.city || el.name}-${index}`}
                xs={1}
                md={1 / 2}
                lg={1 / 3}>
                <ResultContainer onClick={() => handleClick(el)}>
                  <img
                    src={el.picture || cityPlaceholder}
                    role='presentation'
                  />
                  <ResultTitleContainer>
                    <ResultTitle>{el.city || el.name}</ResultTitle>
                  </ResultTitleContainer>
                </ResultContainer>
              </Result>
            )
          })}
        </ResultsContainer>
      </ThemeContainer>
    )
  }

  render () {
    const {
      results,
      title,
      tableKeys,
      path,
      router,
      isFetching,
      parent
    } = this.props
    const resultpath = path && (
      <Path>
        <span
          onClick={() => {
            router.push('/search/region')
          }}>
          Home
        </span>
        {path.continent && (
          <span
            onClick={() => {
              router.push('/search/region/' + path.continent)
            }}>
            {' > ' + path.continent}
          </span>
        )}
        {path.country && (
          <span
            onClick={() => {
              router.push(
                '/search/region/' + path.continent + '/' + path.country
              )
            }}>
            {' > ' + path.country}
          </span>
        )}
        {path.city && (
          <span
            onClick={() => {
              router.push(
                '/search/region/' +
                  path.continent +
                  '/' +
                  path.country +
                  '/' +
                  path.city
              )
            }}>
            {' > ' + path.city}
          </span>
        )}
      </Path>
    )

    return (
      <Container onScroll={this.handleScroll} id={'results-page'}>
        <Loader visible={isFetching && !tableKeys} className='loader' />
        <Image image={parent && parent.picture}>
          <Title>
            <h1>{title}</h1>
            <p>{results && results.length} Results</p>
          </Title>
          {resultpath}
        </Image>
        {parent &&
        parent.description && <Description>{parent.description}</Description>}
        {tableKeys ? this.table() : this.cards()}
      </Container>
    )
  }
}

SearchResult.propTypes = {
  handleClick: PropTypes.func.isRequired,
  results: PropTypes.array,
  title: PropTypes.string,
  loadMore: PropTypes.func,
  isFetching: PropTypes.bool,
  tableKeys: PropTypes.array,
  handleSort: PropTypes.func,
  path: PropTypes.object,
  router: PropTypes.object,
  canLoadMore: PropTypes.bool,
  type: PropTypes.string,
  parent: PropTypes.object
}

export default SearchResult



// WEBPACK FOOTER //
// ./src/pages/Search/SearchResult.js